import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem, Grid, Autocomplete, TextField, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ClearIcon from '@mui/icons-material/Clear';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useSelector } from "react-redux";
import "./style.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
ChartJS.register(ChartDataLabels);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function CostPerTonByScenarioChart(props) {
  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId
  );

  const selectedFolderData = useSelector(
    (state) => state.InputDataReducers.selectedFolderData
  );
  
  console.log(selectedFolderData, "selectedFolderData");
  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);

  const options = {
    plugins: {
      datalabels: {
        anchor: "end",
        align: "top",
        color: "black",
        offset: -3,
        font: {
          weight: "bold",
          size: 12,
        },
        // formatter: Math.round,
        formatter: (value, context) => {
          const datasetArray = [];
          let total;
          function totalSum(total, datapoint) {
            return total + datapoint;
          }
          context.chart.data.datasets.forEach((dataset) => {
            if (dataset.data[context.dataIndex] !== undefined) {
              datasetArray.push(Math.round(dataset.data[context.dataIndex]));
            }
          });
          total = datasetArray.reduce(totalSum, 0);
          if (context.datasetIndex === datasetArray.length - 1) {
            // return NumberFormater(total) + ' Cr';
            return "";
          } else {
            return "";
          }
        },
      },
      title: {
        display: false,
      },
      legend: {
        display: false,
      },

      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toFixed(2);
            }
            return label;
          },
        },
      },
      //  tooltip:
      //       {
      //           callbacks: {
      //               title: function(item){return item.title},
      //               label: function (tooltipItem) { console.log('ToolTip',tooltipItem);
      //                   return tooltipItem.dataset.label + ': ' + tooltipItem.formattedValue + ' cr';},
      //           }
      //       }
      // tooltip: {
      //   callbacks: {
      //     title: function (e) {
      //       return ``;
      //     },
      //     label: function (tooltipItem) {
      //       let cost = datasets[tooltipItem.datasetIndex].data[0];
      //       let displayLabel = datasets[tooltipItem.datasetIndex].label;
      //       return `${NumberFormater(cost)} Cr \n ${displayLabel}`;
      //     }
      //   }
      // }
    },
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "S C E N A R I O",
        },
        barThickness: 8,
        barPercentage: 0.5,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: "probability",
        },
      },
      y: {
        // beginAtZero: true,
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Cost Per Ton (in Lakhs / Ton)",
        },
        ticks: {
          callback: function (value, index, ticks) {
            //console.log(value,"valuetttt")
            return value.toFixed(2);
          },
        },
        stacked: true,
      },
    },
  };

  console.log(options, "optionsData");

  const [labels, setLabels] = useState([])
  useEffect(() => {
    if (props.costPerTonData.length > 0) {
      const finalLabels = [];
      props.costPerTonData?.map((data) => {
        finalLabels.push(data?.chartname)
      });
      setLabels(finalLabels)
    }
  }, [props.costPerTonData])

  console.log(
    "data -- Cost per ton _______________________________________",
    props.costPerTonData
  );
  //console.log('data_latest -- Cost per ton_______________________________', props.timePeriodCostPerTonData)
  // const datasets = [
  //   {
  //     label: 'Outbound Production Cost',
  //     data: props.costPerTonData && props.costPerTonData.map((item) => item["Conversion Cost"]),
  //     backgroundColor: '#001f82'
  // },
  // {
  //     label: 'Inbound Transportation Cost',
  //     data: props.costPerTonData && props.costPerTonData.map((item) => item["Landed Cost"]),
  //     backgroundColor: '#00aaf4'
  // },
  // {
  //     label: 'Procurement Cost',
  //     data: props.costPerTonData && props.costPerTonData.map((item) => item["Pri Transportation Cost"]),
  //     backgroundColor: '#9c44c0'
  // }
  // ];

  var datasets = [];
  console.log(props.costPerTonData, 'props.costPerTonData')
  const homedatasets = [
    {
      label: "Packaging cost/ Tonne",
      data:
        props.costPerTonData && props.costPerTonData?.map((item) => item["Packaging cost/ Tonne"]),
      backgroundColor: "#FF9998",
    },
    // {
    //   label: "Conversion Cost",
    //   data:
    //     props.costPerTonData &&
    //     props.costPerTonData?.map((item) => item["Conversion Cost"]),
    //   backgroundColor: "#FFEC9A",
    // },
    // {
    //   label: "Pri Transportation Cost",
    //   data:
    //     props.costPerTonData &&
    //     props.costPerTonData?.map((item) => item["Pri Transportation Cost"]),
    //   backgroundColor: "#FFC000",
    // },
    // {
    //   label: "Processing cost_Tonne",
    //   data:
    //     props.costPerTonData &&
    //     props.costPerTonData.map((item) => item["Processing cost_Tonne"]),
    //   backgroundColor: "#FFEC9A",
    // },
  ];
  console.log(
    props.costPerTonData &&
    props.costPerTonData?.map((item) => item["Landed Cost"]),
    "propscostPerTonData"
  );

  //   const nutritiondatasets = [
  //     {
  //       label: 'Conversion Cost',
  //       data: props.costPerTonData && props.costPerTonData.map((item) => item["Conversion Cost"]),
  //       backgroundColor: '#1F36C7'
  //   },
  //     {
  //       label: 'Processing cost_Tonne',
  //       data: props.costPerTonData && props.costPerTonData.map((item) => item["Processing cost_Tonne"]),
  //       backgroundColor: '#1F36C7'
  //   },
  //   {
  //     label: 'SFG transportation cost_Tonne',
  //     data: props.costPerTonData && props.costPerTonData.map((item) => item["SFG transportation cost_Tonne"]),
  //     backgroundColor: '#9C44C0'
  // },

  //     {
  //       label: 'Packaging cost_Tonne',
  //       data: props.costPerTonData && props.costPerTonData.map((item) => item["Packaging cost_Tonne"]),
  //       backgroundColor: '#00B2FF'
  //   },
  //     {
  //       label: 'Primary Transportation cost_Tonne',
  //       data: props.costPerTonData && props.costPerTonData.map((item) => item["Primary Transportation cost_Tonne"]),
  //       backgroundColor: 'palevioletred'
  //   },

  //   ];

  const nutritiondatasets = [
    // {
    //   label: "Packaging cost",
    //   data:
    //     props.costPerTonData &&
    //     props.costPerTonData.map((item) => item["Packaging cost Tonne"]),
    //   backgroundColor: "#FF9998",
    // },
    {
      label: "RMPM Procurement Cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map((item) => item["RMPM Procurement cost Tonne"]),
      backgroundColor: "#b8ffbd",
    },
    {
      label: "Processing cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map((item) => item["Processing cost Tonne"]),
      backgroundColor: "#FFEC9A",
    },
    {
      label: "RMPM Transportation Cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map(
          (item) => item["RMPM Transportation cost Tonne"]
        ),
      backgroundColor: "#A3E1D2",
    },
    {
      label: "RMPM Landed cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map(
          (item) => item["RMPM Landed cost Tonne"]
        ),
      backgroundColor: "#A3E1D2",
    },
    {
      label: "RMPM Landed cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map(
          (item) => item["RM Landed Cost Tonne"]
        ),
      backgroundColor: "#A3E1D2",
    },
    {
      label: "Packaging Cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map((item) => item["Packaging cost Tonne"]),
      backgroundColor: "#00B190",
    },

    {
      label: "Primary Transportation cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map(
          (item) => item["Primary Transportation cost Tonne"]
        ),
      backgroundColor: "#FFC000",
    },

    {
      label: "SFG Transportation Cost Tonne",
      data:
        props.costPerTonData &&
        props.costPerTonData.map(
          (item) => item["SFG transportation cost Tonne"]
        ),
      backgroundColor: "#FFC000",
    },
  ];

  if (selectedCategoryId === 1) {
    datasets = homedatasets;
  } else {
    datasets = nutritiondatasets;
  }


  
  const [selectedScenarios, setSelectedScenarios] = useState([])
  const handleChangeSelectScenario1 = (event, newSelected) => {
    if (newSelected.length > 0) {

    setSelectedScenarios((prevSelected) => {
        const updatedSelected = [...prevSelected];
        const scenario = newSelected[newSelected.length - 1];
    
        if (updatedSelected.some((item) => item.scenario === scenario.scenario)) {
          // Scenario is already selected, so deselect it
          const indexToRemove = updatedSelected.findIndex(
            (item) => item.scenario === scenario.scenario
          );
          updatedSelected.splice(indexToRemove, 1);
        } else {
          // Scenario is not selected, so add it
          updatedSelected.push(scenario);
        }
    
        return updatedSelected;
      });
      console.log(selectedScenarios, newSelected, "newSelected");
    // loadCharts(selectedInnerFolderId,newValue,selectScenario2Id);
    }else {
      setSelectedScenarios([])
    }
  }

  
  let uc = localStorage.getItem("selectedUsecase");
  let sr = localStorage.getItem("selectedRadio");
  const [shortTermStatus, setShortTermStatus] = useState(false);
  const [mediumTermStatus, setMediumTermStatus] = useState(false);
  useEffect(() => {
    if (uc === "Short Term") {
      if (sr === "masterData") {
        setShortTermStatus(true);
      } else {
        setShortTermStatus(false);
      }
    } else {
      if (sr === "masterData") {
        setMediumTermStatus(true);
      } else {
        setMediumTermStatus(false);
      }
    }
  }, [uc, sr]);
  console.log(uc, sr, shortTermStatus, mediumTermStatus, "statusss");
  const scenarioOptions = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Conversion Cost",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Landed Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
  ];

  const nutritionScenarioOptions = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM transportation cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM procurement cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
  ];


  const nutritionScenarioOptions2 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Landed cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost Tonne",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost Tonne",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
  
  
   
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM transportation cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM procurement cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
  ];

  const nutritionScenarioOptions3 = [
    {
      scenario_id: 0,
      folder_id: 0,
      scenario: "RMPM Procurement Cost Tonne",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 0,
      folder_id: 0,
      scenario: "RMPM Transportation Cost Tonne",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 0,
      scenario: "Packaging Cost Tonne",
      filetype: 3,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 0,
      folder_id: 0,
      scenario: "Primary Transportation Cost Tonne",
      filetype: 4,
      scenario_time: null,
      number: 1480,
    },
 
  ];
  const nutritionScenarioOptions4 = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "RMPM Landed Cost Tonne",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
  
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Packaging Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Primary Transportation Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
 
  ];
  const nutritionScenarioOptions5 = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "RMPM Procurement Cost Tonne",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "RMPM Transportation Cost Tonne",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost Tonne",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost Tonne",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
 
  ];
  const nutritionScenarioOptions6 = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "RMPM Landed Cost Tonne",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
  
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation Cost Tonne",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost Tonne",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost Tonne",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
  ];

  let scenarioNames;
  
  if (folderModuleName === "module2") {
    scenarioNames = nutritionScenarioOptions2?.map(item => item.scenario);
  } else if (folderModuleName === "module3") {
    scenarioNames = nutritionScenarioOptions3?.map(item => item.scenario)
  } else if (folderModuleName === "module4") {
    scenarioNames = nutritionScenarioOptions4?.map(item => item.scenario)
  }else if (folderModuleName === "module5") {
    scenarioNames = nutritionScenarioOptions5?.map(item => item.scenario)
  }else if (folderModuleName === "module6") {
    scenarioNames = nutritionScenarioOptions6?.map(item => item.scenario)
  } else {
    scenarioNames = nutritionScenarioOptions?.map(item => item.scenario)

  }

//const scenarioNames = sr === "masterData" ? scenarioOptions.map(item => item.scenario): nutritionScenarioOptions.map(item => item.scenario);

  const [selectedScenario, setSelectedScenario] = useState([]);
  console.log(selectedScenario, "seseesesee")

  const handleScenarioChange = (event) => {
    setSelectedScenario(event.target.value);
  };

  const handleClear = () => {
    setSelectedScenario([]);
  };

  console.log("Result data --Over All:", datasets);
  
  const filterArray = [];
  if (selectedScenarios) {
      selectedScenarios.map((item) => {
          filterArray.push(item.scenario);
      })
  }
  console.log(filterArray, "filterArray");

  if (selectedScenario.length > 0) {
      
      const maxDataLength = Math.max(...datasets.map(item => item.data.length));

      datasets.forEach(item => {
          let isMatched = false;
          for (const filterString of selectedScenario) {
              if (item.label.toLowerCase().includes(filterString.toLowerCase())) {
                  isMatched = true;
                  break;
              }
          }
          if (!isMatched) {
              item.data = Array(maxDataLength).fill(0);
          }
      });

  }
  

  const baselineData = {
    labels: labels,
    datasets,
  };

  console.log(baselineData, "base_Line___");

  // cost per ton split by time chart
  // const options01 = {
  //   plugins: {
  //     datalabels: {
  //       display: true,
  //       color: "black",
  //       // formatter: Math.round,
  //       formatter: (value, context) => {
  //         const datasetArray = [];
  //         let total;
  //         function totalSum(total, datapoint) {
  //           return total + datapoint;
  //         }
  //         context.chart.data.datasets.forEach((dataset) => {
  //           if (dataset.data[context.dataIndex] !== undefined) {
  //             datasetArray.push(dataset.data[context.dataIndex]);
  //           }
  //         });
  //         total = datasetArray.reduce(totalSum, 0);
  //         if (context.datasetIndex === datasetArray.length - 1) {
  //           // return NumberFormater(total) + ' Cr';
  //           return '';
  //         } else {
  //           return '';
  //         }
  //       },
  //       anchor: "end",
  //       offset: -20,
  //       align: "start"
  //     },
  //     title: {
  //       display: false,
  //       // text: 'Chart.js Bar Chart - Stacked',
  //     },
  //     legend: {
  //       display: false,
  //     },
  //   },
  //   responsive: true,
  //   scales: {
  //     x: {
  //       grid: {
  //         display: false,
  //         //drawBorder: false
  //       },
  //       title: {
  //         display: true,
  //         text: 'T I M E  P E R I O D'
  //       },
  //       barThickness: 8,  // number (pixels) or 'flex'
  //       barPercentage: 0.5,
  //       stacked: true,

  //       scaleLabel: {
  //         display: true,
  //         labelString: 'probability'
  //       }
  //     },
  //     y: {
  //       grid: {
  //         display: false,
  //         //drawBorder: false
  //       },
  //       title: {
  //         display: true,
  //         text: 'C O S T'
  //       },
  //       ticks: {
  //         callback: function(value, index, ticks) {
  //           return value +' Ton';
  //         }
  //       },
  //       stacked: true,
  //       categoryPercentage: 0.4,
  //     },
  //   },
  // };

  const options01 = {
    plugins: {
      categoryPercentage: 0.4,
      barPercentage: 0.5,
      datalabels: {
        display: true,
        color: "black",
        // formatter: Math.round,
        formatter: (value, context) => {
          const datasetArray = [];
          let total;
          function totalSum(total, datapoint) {
            return total + datapoint;
          }
          context.chart.data.datasets.forEach((dataset) => {
            if (dataset.data[context.dataIndex] !== undefined) {
              datasetArray.push(dataset.data[context.dataIndex]);
            }
          });
          total = datasetArray.reduce(totalSum, 0);
          if (context.datasetIndex === datasetArray.length - 1) {
            // return NumberFormater(total) + ' Cr';
            return "";
          } else {
            return "";
          }
        },
        anchor: "end",
        offset: -20,
        align: "start",
      },
      title: {
        display: false,
        // text: 'Chart.js Bar Chart - Stacked',
      },
      legend: {
        display: false,
      },

      // tooltip: {
      //   callbacks: {
      //     label: function (context) {
      //       var label = context.dataset.label || '';
      //       if (label) {
      //         label += ': ';
      //       }
      //       if (context.parsed.y !== null) {
      //         label += context.parsed.y.toFixed(5);
      //       }
      //       return label;
      //     },
      //   },
      // },

      tooltip: {
        callbacks: {
          title: function (item) {
            return item.title;
          },
          label: function (tooltipItem) {
            console.log("ToolTip", tooltipItem);
            //return tooltipItem.dataset.label + ': ' + tooltipItem.formattedValue + ' cr';},
            return (
              tooltipItem.dataset.cost +
              ":" +
              tooltipItem.dataset.label +
              " : " +
              tooltipItem.formattedValue
            );
          },
        },
      },

      // tooltip: {
      //     callbacks: {
      //         title: function (e) {
      //             return ``;
      //         },
      //         label: function (tooltipItem) {
      //             let cost = datasets[tooltipItem.datasetIndex].data[0];
      //             let displayLabel = datasets[tooltipItem.datasetIndex].label + ': ';
      //             //return `${NumberFormater(cost)} Cr \n ${displayLabel}`;
      //             return `${displayLabel}${NumberFormater(cost)} Cr `;
      //         }
      //     }
      // }
    },
    responsive: true,
    barPercentage: 0.5,
    scales: {
      x: {
        maxBarThickness: 100,
        categoryPercentage: 0.4,
        barPercentage: 0.5,
        grid: {
          display: false,
          //drawBorder: false
        },
        title: {
          display: true,
          text: "T I M E  P E R I O D",
        },
        barThickness: 10, // number (pixels) or 'flex'
        // barPercentage: 10,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: "probability",
        },
      },
      y: {
        categoryPercentage: 10,
        grid: {
          display: false,
          //drawBorder: false
        },
        title: {
          display: true,
          text: "Cost Per Ton (in Lakhs / Ton)",
        },
        ticks: {
          callback: function (value, index, ticks) {
            return value.toFixed(6);
            console.log(value, "valuesyyyy");
          },
        },
        stacked: true,
      },
    },
  };

  const labelTimePeriod = props.timePeriodCostPerTonData.label;
  console.log(props, "propsee");

  const data01 = {
    labels: labelTimePeriod,
    datasets: props.timePeriodCostPerTonData.data,
  };



  const data = baselineData?.datasets;
    const sums = Array(data[0].data?.length).fill(0);

    data?.forEach(item => {
      item?.data?.forEach((value, index) => {
        if (value !== null && value !== undefined) {
          sums[index] += value;
        }
      });
    });
    
    console.log(sums, "sm");
    useEffect(() => {
      setSelectedScenario([]);
   }, [selectedFolderData])
   
  return (
    <>

      <div className="chart-block">
        <div className="chart-container">
          <div className="dropdown_container">
            <div className="pull-left"> <h2>Cost Per Ton By Scenario (in Lakhs/Ton)</h2></div>
              <div className="pull-right">
              <FormControl sx={{ m: 1, width: 300 }}>
              <InputLabel id="demo-multiple-checkbox-label">Filter By Cost</InputLabel>
              <Select
                id="scenario-multi-select"
                multiple
                value={selectedScenario}
                onChange={handleScenarioChange}
                input={
                  <OutlinedInput
                    label="Select Scenarios"
                    endAdornment={
                      selectedScenario.length > 0 && (
                        <ClearIcon
                          style={{ cursor: 'pointer' }}
                          onClick={handleClear}
                        />
                      )
                    }
                  />
                }
                renderValue={(selected) => selected.join(', ')}
               
              >
                {scenarioNames.map((scenario) => (
                  <MenuItem key={scenario} value={scenario}>
                    <Checkbox checked={selectedScenario.indexOf(scenario) > -1} />
                    <ListItemText primary={scenario} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
              </div>
          </div>
          <br />
          <div className="sum_container">
          {sums.map((item) => (
              <div>{item !==0 ? <div className="sum_container_items">{item.toFixed(2)}</div> : ""}</div>
       ))}
      </div>
          <Bar options={options} data={baselineData} height="100" />
        </div>
      </div>
      {/* <Grid item xs={7} md={7} lg={7} className="chart-block">
          <div className="chart-container">
            <h2>Cost per Ton split by time</h2>
            <Bar data={data01} options={options01} />
          </div>
        </Grid> */}

    </>
  );
}

export default CostPerTonByScenarioChart;
